<script setup>
defineProps({
  name: {
    type: String,
    default: undefined,
  },
  departureName: {
    type: String,
    default: undefined,
  },
  arrivalName: {
    type: String,
    default: undefined,
  },

  withBack: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(['close', 'back']);
</script>

<template>
  <div class="forms-search-screen-wrapper">
    <FormsSearchHeader
      class="forms-search-screen-wrapper__header"
      :name="name"
      :arrival-name="arrivalName"
      :departure-name="departureName"
      :with-back="withBack"
      @close="emit('close')"
      @back="emit('back')"
    />

    <slot />
  </div>
</template>

<style scoped lang="scss">
.forms-search-screen-wrapper {
  $parent: &;

  display: flex;
  flex-grow: 1;
  flex-direction: column;
  padding-top: em(20);
  padding-bottom: em(20);
  background-color: $color-white;

  &__header {
    flex-shrink: 0;
    padding: 0 em(16);
    margin-bottom: em(16);
  }
}
</style>
